import React from 'react';
import { StepDatosGenerales } from './steps/StepDatosGenerales';
import { StepRequisitosClientes } from './steps/StepRequisitosClientes';
import { StepRequisitosTipoPrograma } from './steps/StepRequisitosTipoPrograma';
import { StepAdicionalesMinuta } from './steps/StepAdicionalesMinuta';
import { StepBloqueos } from './steps/StepBloqueos';

export const STEPS = [
    {
        stepKey: 'datosGenerales',
        stepName: 'Datos generales',
        status: 'ACTIVE',
        order: 0,
        component: <StepDatosGenerales />
    },
    {
        stepKey: 'requisitosClientes',
        stepName: 'Requisitos clientes',
        status: 'INACTIVE',
        order: 1,
        component: <StepRequisitosClientes />
    },
    {
        stepKey: 'requisitosTipoPrograma',
        stepName: 'Requisitos por tipo de programa',
        status: 'INACTIVE',
        order: 2,
        component: <StepRequisitosTipoPrograma />
    },
    {
        stepKey: 'adicionalesMinuta',
        stepName: 'Adicionales minuta',
        status: 'INACTIVE',
        order: 3,
        component: <StepAdicionalesMinuta />
    },
    {
        stepKey: 'bloqueos',
        stepName: 'Bloqueos',
        status: 'INACTIVE',
        order: 4,
        component: <StepBloqueos />
    },
];